// Returns null for missing/invalid JSON so the placeholder can stay in the page.
// Shape checks stay in the caller.

export function parseJsonConfig(element, {attribute = 'config', warnLabel = 'html-island'} = {}) {
  const raw = element.getAttribute(attribute);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn(`${warnLabel}: invalid config JSON`, error);
    return null;
  }
}
